const formEquipmentsLogs = {
  actionsNotFound: 'No logs found'
};

export default formEquipmentsLogs;
